import React from 'react'
import { ObjectFieldsComponent } from './ObjectFieldsComponent'
import { Col, Row } from 'antd'

export const ReservePlaceAndTimeComponent = ({ setLoading, showMessage, reserve, showTitle = true }) => {
    return (
        < >
            {showTitle ? <Row className='sectionTitle'>
                <Col span={24}>
                    <h2 >
                        زمان / مکان رزرو شده
                    </h2>
                </Col>
            </Row> : <></>}

            <div className='container'>
                <Row wrap='wrap'>
                    <Col xs={24} sm={6} md={6} lg={6} xl={6} className='reserve-timing-main-column'>
                        <div className='reserve-timing-value-title'>
                            رزرو شده
                        </div>

                        <div className='reserve-timing-value-column'>
                            <span>{reserve.objectInstance.title} </span>
                            <ObjectFieldsComponent
                                setLoading={setLoading}
                                showMessage={showMessage}
                                objectInstanceId={reserve.objectInstanceId}
                            />
                        </div>
                    </Col>

                    <Col xs={24} sm={6} md={6} lg={6} xl={6} className='reserve-timing-main-column'>

                        <div className='reserve-timing-value-title'>
                            شروع اقامت
                        </div>

                        <div className='reserve-timing-value-column'>
                            <div>
                                <span>از تاریخ </span>
                                <span>{reserve.from_Shamsi_DayOfWeek} </span>
                                <div style={{ display: 'inline' }} >{reserve.from_Shamsi}</div>
                            </div>
                        </div>
                    </Col>

                    <Col xs={24} sm={6} md={6} lg={6} xl={6} className='reserve-timing-main-column'>
                        <div className='reserve-timing-value-title'>
                            پایان اقامت
                        </div>

                        <div className='reserve-timing-value-column'>
                            <div>
                                <span>تا تاریخ </span>
                                <span>{reserve.to_Shamsi_DayOfWeek} </span>
                                <div style={{ display: 'inline' }} >{reserve.to_Shamsi}</div>
                            </div>
                        </div>
                    </Col>

                    <Col xs={24} sm={6} md={6} lg={6} xl={6} className='reserve-timing-main-column'>
                        <div className='reserve-timing-value-title'>
                            دوره
                        </div>

                        <div span={24} className='reserve-timing-value-column'>
                            {reserve.period.title}
                        </div>
                    </Col>
                </Row>
            </div>

        </>
    )
}

